<template>
  <div class="backgg scroll">
      <div class="transparant text-center" >
          <br>
          <span class="huruf_dashboar">e-Government</span> <br>
          <span class="huruf_dashboar1">Kabupaten Konawe Selatan</span>
          <br><br>
      </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8">
          <br><br>
        <div class="card">
          <div class="body">
              <div class="row">
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="office">
                              <img src="images/icon/office.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="planing">
                              <img src="images/icon/planning.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="aset">
                              <img src="images/icon/aset.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="monev">
                              <img src="images/icon/monev.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="berita">
                              <img src="images/icon/berita.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="pengaduan">
                              <img src="images/icon/pengaduan.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="sakip">
                              <img src="images/icon/sakip.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="bhumie">
                              <img src="images/icon/bhumie.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>

                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="cctv">
                              <img src="images/icon/cctv.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="simpeg">
                              <img src="images/icon/simpeg.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="linja">
                              <img src="images/icon/linja.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3 col-xs-6">
                      <div >
                          <a href="javascript:void(0);" @click="registrasi">
                              <img src="images/icon/registrasi.png" class="img-responsive" />
                          </a>
                      </div>
                  </div>
                  

              </div>





          </div>
        </div>
      </div>
      <div class="col-md-2"></div>
    </div>
    <br>
  </div>
</template>

<script>

// const ADD_URL = URL_APP + "api/v1/rincian_obyek/";

  import Joi from "joi";
  const LOGIN_URL =  URL_APP + "auth/login";

  const schema = Joi.object().keys({
    username: Joi.string().regex(/^[a-zA-Z0-9_]*$/).min(3).max(13).required(),
    password: Joi.string().min(6).required(),
  });

  export default {
    name: "monev_login",
    data : function(){
      return {
          LoggingIn: false,
          errorMessage: '',
          user : {
            username : "",
            password : ""
          },
          profile : JSON.parse(localStorage.profile).profile,
      }
    },
    methods : {
        office : function(){
            if (this.profile.Office) {
                this.$router.push('/office');
                location.reload();
            }else{
                this.alertku('error', 'Anda Tidak Memiliki Hak Akses Ke Aplikasi Ini!');
            }

        },
        planing : function(){

            // this.$router.push('/planing');
            // location.reload();


            if (this.profile.Planing) {
                this.$router.push('/planing_renja_program');
                location.reload();
            }else{
                this.alertku('error', 'Anda Tidak Memiliki Hak Akses Ke Aplikasi Ini!');
            }
        },
        aset : function(){
            location.reload();
        },
        monev : function(){
            location.reload();
        },
        berita : function(){
            location.reload();
        },
        pengaduan : function(){
            location.reload();
        },
        sakip : function(){
            if (this.profile.Planing) {
                this.$router.push('/sakip_pk_lv_1');
                location.reload();
            }else{
                this.alertku('error', 'Anda Tidak Memiliki Hak Akses Ke Aplikasi Ini!');
            }
        },
        bhumie : function(){
            if (this.profile.Bhumie) {
                this.$router.push('/bhumie');
                location.reload();
            }else{
                this.alertku('error', 'Anda Tidak Memiliki Hak Akses Ke Aplikasi Ini!');
            }
        },
        linja : function(){
            location.reload();
        },
        cctv : function(){
            location.reload();
        },
        simpeg : function(){
            if (this.profile.Simpeg) {
                this.$router.push('/simpeg');
                location.reload();
            }else{
                this.alertku('error', 'Anda Tidak Memiliki Hak Akses Ke Aplikasi Ini!');
            }
        },
        registrasi : function(){
            this.$router.push('/reg_registrasi');
                location.reload();
            // if (this.profile.Registrasi) {
            //     this.$router.push('/reg_registrasi');
            //     location.reload();
            // }else{
            //     this.alertku('error', 'Anda Tidak Memiliki Hak Akses Ke Aplikasi Ini!');
            // }
        },
        alertku : function(type, title){
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 2000
            });
        },
    },
    mounted : function(){
      var element = document.getElementById('main_menu');
      element.parentNode.removeChild(element);

      var profil = JSON.parse(localStorage.profile);
      this.profile = profil.profile;
      console.log(this.profile);
    },



  };
</script>

<style>
.backgg {
  background: url('../../public/images/2.jpg') no-repeat center center
    fixed;
  /* background-image: url(https://i.stack.imgur.com/7X3An.png) ; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;

  min-width: 100%;
  min-height: 100%;
}
.paddingku {
  /* padding: 1%; */
  position: relative;
  top: 40%;
  transform: translateY(25%);
}
</style>
